'use client'

import React from 'react'
import { usePathname } from 'next/navigation'
import { shouldUseAppShell } from '@/lib/route-config'
import { GuestRoute } from '@/components/auth/guest-route'

interface DynamicLayoutProps {
  children: React.ReactNode
}

/**
 * Root layout switcher:
 * - Public pages: bare children
 * - Auth pages: GuestRoute + centered card
 * - App pages: children only (persistent AppShell lives in app/(dashboard)/layout.tsx)
 */
export default function DynamicLayout({ children }: DynamicLayoutProps) {
  const pathname = usePathname()

  if (!shouldUseAppShell(pathname)) {
    if (pathname === '/' || pathname === '/terms' || pathname === '/privacy') {
      return <>{children}</>
    }

    return (
      <GuestRoute>
        <div className='min-h-screen bg-gradient-soft flex items-center justify-center p-4'>
          <div className='w-full max-w-md'>{children}</div>
        </div>
      </GuestRoute>
    )
  }

  // Authenticated app routes — shell is provided by (dashboard)/layout
  return <>{children}</>
}
